import api from './api';

const CompetitionService = {
  getActive: () => api.get('/competition/active'),
  getById: (id) => api.get(`/competition/${id}`),

  // Admin
  create: (data) => api.post('/competition', data),
  getAll: () => api.get('/competition'),
  update: (id, data) => api.put(`/competition/${id}`, data),
  openRegistration: (id) => api.post(`/competition/${id}/open-registration`),
  advanceRound: (id) => api.post(`/competition/${id}/advance-round`),
  setLocationBrief: (id, data) => api.put(`/competition/${id}/location-brief`, data),
  reset: (id) => api.post(`/competition/${id}/reset`),
};

export default CompetitionService;
